const DisagreeDialog = ({ requestPaperFormHandler, continueToElectronicHandler, employmentLocation }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            {/* Dialog box */}
            <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6 mx-4 break-words">
                <p className="text-sm sm:text-base font-medium mb-4">
                    To complete the background screening process in non-electronic form, please contact
                    VerifiedID at
                    {employmentLocation?.country !== "India" && (
                        <>
                            {" "}
                            Phone:{" "}
                            <a href="tel:+18887182597" className="text-blue-600 underline">
                                (888) 718-2597
                            </a>
                            , or
                        </>
                    )}{" "}
                    Email:{" "}
                    <a href="mailto:support@verifiedid.co" className="text-blue-600 underline">
                        support@verifiedid.co
                    </a>{" "}
                    for further instructions.
                </p>
                <div className="flex justify-end gap-2">
                    <button
                        onClick={requestPaperFormHandler}
                        className="px-4 py-2 bg-green-600 text-white text-sm rounded hover:bg-green-700"
                    >
                        Request Paper Form
                    </button>
                    <button
                        onClick={continueToElectronicHandler}
                        className="px-4 py-2 bg-gray-600 text-white text-sm rounded hover:bg-gray-700"
                    >
                        Continue to Electronic
                    </button>
                </div>
            </div>

        </div>
    )
}

export default DisagreeDialog
